export default {
      state: {},
      reducers: {
            silence() {
                  return {};
            },
            error(state, message) {
                  return { color: "danger", message };
            },
            success(state, message) {
                  return { color: "success", message };
            }
      }
};
